import {styled} from "@mui/material/styles"

export const Cotton22SearchBarContainer = styled("div")`
    display: flex;
    flex-shrink: 0;
    padding: 0.75rem 1rem;
    background-color: ${({theme}) => theme.colours.grey[100]};
    border-bottom: ${({theme}) => `0.0625rem solid ${theme.colours.grey[300]}`};
`
export default Cotton22SearchBarContainer
